// https://github.com/cornerstonejs/cornerstone3D-beta/blob/main/utils/demo/helpers/initDemo.js

import initProviders from "./providers/initProviders";
import initCornerstoneWADOImageLoader from "./loaders/initWADOLoader";
import initVolumeLoader from "./loaders/initVolumeLoader";
import { init as csRenderInit, imageLoader } from "@cornerstonejs/core";
import {
  cornerstoneNiftiImageLoader,
  init as niftiInit,
} from "@cornerstonejs/nifti-volume-loader";
import {
  init as csToolsInit,
  state,
  StackScrollTool,
  // StackScrollMouseWheelTool,
  addTool,
  CrosshairsTool,
  WindowLevelTool,
  PanTool,
  ZoomTool,
  BrushTool,
} from "@cornerstonejs/tools";

export default async function initCornerstone() {
  initProviders();
  initCornerstoneWADOImageLoader();
  initVolumeLoader();
  csToolsInit();
  await csRenderInit();

  // ========== Register Nifti Image Loader ========== //
  imageLoader.registerImageLoader("nifti", cornerstoneNiftiImageLoader);

  niftiInit();
  // Add Tools globally to cornerstone
  if (state.tools[StackScrollTool.toolName] === undefined) {
    addTool(StackScrollTool);
    addTool(CrosshairsTool);
    addTool(WindowLevelTool);
    addTool(PanTool);
    addTool(ZoomTool);
    addTool(BrushTool);
  }
}
